import React, { useState, useEffect } from "react";

function Footer() {
  return (
    <div id="footer" className="footer_wrapper">
      <div className="d-flex justify-content-center col-12 m-auto pt-24">
        <div className="pt-24 pb-24 px-16">
          <div className="md-row justify-content-center">
            <p>Säkerhetskonsulterna Sverige AB</p>
          </div>
          <div>
            <div className="xs-col md-row justify-content-center">
              <p className="color-link-white">
                <a href="mailto:info@sakerhetskonsulterna.com">
                  info@sakerhetskonsulterna.com
                </a>
              </p>
            </div>
          </div>
          <div>
            <div className="xs-col md-row justify-content-center">
              <p className="color-link-white">Tel: 08-100 900</p>
            </div>
          </div>
          <div>
            <div className="xs-col md-row justify-content-center">
              <p className="pr-8">Gyllenborgsgatan 4,</p>
              <p>112 43 Stockholm</p>
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center">
        <p className="fs-12 ">
          © 2024 Säkerhetskonsulterna Sverige AB. All rights reserved.
        </p>
      </div>
    </div>
  );
}

export default Footer;
